import { useEffect, useRef } from "react";

const GoogleMapPickerScript = ({ onSelect, lat, lng }: any) => {
  const mapRef = useRef<HTMLDivElement | null>(null);
  const mapInstance = useRef<any>(null);
  const markerRef = useRef<any>(null);

  useEffect(() => {
    if (!(window as any).google || !mapRef.current) return;

    const center = lat && lng
      ? { lat: parseFloat(lat), lng: parseFloat(lng) }
      : { lat: 7.8731, lng: 80.7718 };

    mapInstance.current = new (window as any).google.maps.Map(
      mapRef.current,
      {
        center,
        zoom: lat && lng ? 12 : 7,
      }
    );

    if (lat && lng) {
      markerRef.current = new (window as any).google.maps.Marker({
        position: center,
        map: mapInstance.current,
      });
    }

    mapInstance.current.addListener("click", (e: any) => {
      const position = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };

      if (markerRef.current) {
        markerRef.current.setPosition(position);
      } else {
        markerRef.current = new (window as any).google.maps.Marker({
          position,
          map: mapInstance.current,
        });
      }

      onSelect(position);
    });
  }, []);

  return (
    <div
      ref={mapRef}
      className="w-full h-[300px] rounded border"
    />
  );
};

export default GoogleMapPickerScript;